import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bemerkung"
export default class extends Controller {
	static targets = ["kartentext"]

	connect() {
		this.kartentextTargets.forEach((e) => (e.dataset.action = "click->bemerkung#toggle"))
	}

	toggle() {
		this.kartentextTargets.forEach((e) => e.classList.toggle("line-clamp-5"))
	}
}
